import * as React from 'react';
import './styles.scss';
import LayoutSplitColumn, { ILayoutSplitColumnProps } from '../LayoutSplitColumn';

export interface ILayoutSplitProps {
    /** Children */
    children?: React.ReactElement<ILayoutSplitColumnProps, typeof LayoutSplitColumn>[];
}

interface IState {
}

/**
 * Renders split columns layout.
 */
class LayoutSplit extends React.Component<ILayoutSplitProps, IState> {
    static displayName: string = 'LayoutSplit';

    render () {
        return (
            <div className="layout-split layout-split-default">
                {this.props.children}
            </div>
        );
    }
}

export default LayoutSplit;
